import {Component, Injector} from '@angular/core';
import {BaseAdminPanelComponent} from "../../base-admin-panel/base-admin-panel.component";
import {Observable} from "rxjs";
import { ReportTemplateViewModel } from '../Models/ReportTemplateViewModel';
import { CreateReportTemplateComponent } from '../create-report-template.component';
import { EditReportTemplateComponent } from '../edit-report-template.component';
import { ReportTemplateService } from '../../../../services/reporttemplate.service';

@Component({
    selector: '[app-report-templates]',
    templateUrl: './report-templates.component.html',
    styleUrls: ['./report-templates.component.css'],
    standalone: false
})
export class ReportTemplatesComponent extends BaseAdminPanelComponent{

  protected reportService: ReportTemplateService;
  public reportTypes = new Map<number, string>();

  constructor(protected injector: Injector)
  {
    super(injector);
    this.reportService = injector.get(ReportTemplateService);
    this.entityName = "Report templates";

    this.reportService.getReportTypes()
      .subscribe(types => { this.reportTypes = types; });
  }

  protected Refresh() {
    this.reportService.getReportTemplates()
      .subscribe(reports => {
        this.objects = reports;
    });
  }


  protected doDeleteObject(id: number): Observable<any>
  {
    return this.reportService.delete(id);
  }

  public openCreateModal() {
    this.prepareModal(CreateReportTemplateComponent);
    this.componentRef.instance.open(new ReportTemplateViewModel());
  }

  public openEditModal(command: ReportTemplateViewModel) {
    this.prepareModal(EditReportTemplateComponent);
    this.componentRef.instance.open(command);
  }
}
